import React from 'react';
import { BgLogin } from './Macros.styles';
import { useQuery } from 'react-query';
import ViewAllMacros from 'components/kb/macros/ViewAllMacros';

const Macros = () => {
  const { data: getMacros, isLoading: loadingMacros } = useQuery('/admin/kb/macros');
  const { data: getSubStatus } = useQuery('/admin/kb/macros/definitions');
  const { data: getDeparment } = useQuery('/admin/tickets/department/definitions');

  return (
    <BgLogin>
      <ViewAllMacros
        getDeparment={getDeparment}
        getMacros={getMacros}
        loadingMacros={loadingMacros}
        getSubStatus={getSubStatus}
      />
    </BgLogin>
  );
};

export default Macros;
